import { Component, OnInit } from '@angular/core';
import {
  AttributeDefinitionUsageReport,
  FormUsageReport
} from '../../models/attributes/attributeDefinitionUsageReport ';
import { AttributeUiTypeDetails } from '../../models/attributes/attributeUiTypeDetails';
import { AttributeDefinition } from '../../models/attributes/attributeDefinition';
import { AttributeService } from '../../services/attribute.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormType } from '../../models/application/formType';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'custom-field-usage-report',
  templateUrl: './custom-field-usage-report.component.html',
  styleUrls: ['./custom-field-usage-report.component.scss'],
  standalone: false
})
export class CustomFieldUsageReportComponent implements OnInit {
  report: AttributeDefinitionUsageReport;
  forms$: BehaviorSubject<FormUsageReport[]> = new BehaviorSubject<FormUsageReport[]>([]);
  constructor(
    private attributeService: AttributeService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.attributeService
      .getUsageReport({
        id: this.route.snapshot.params['id']
      } as AttributeDefinition)
      .then(async (report) => {
        this.report = report;

        // Delay function
        const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

        // Create a lazy-loaded list with a delay for each form
        const _forms: FormUsageReport[] = [];
        for (const form of report.associatedForms) {
          _forms.push(form);
          this.forms$.next([..._forms]); // Emit updated list
          await delay(0); // Introduce a slight delay
        }
      });
  }

  get uiName(): string {
    return new AttributeUiTypeDetails(this.report?.associatedUIType)?.name;
  }

  async getForms() {}
  navigateTo(form: FormUsageReport) {
    switch (form.formType) {
      case FormType.Application:
      case FormType.Team:
        this.router.navigateByUrl(`/admin/forms/${form.id}`);
        break;
      case FormType.Survey:
        this.router.navigateByUrl(`/admin/surveys/${form.id}`);
        break;
      case FormType.Evaluation:
        this.router.navigateByUrl(`/admin/evaluations/${form.id}`);
        break;
    }
  }
  closeSideBar() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }
}
